import HttpRequest from "../../utilities/httpRequest";
import {
  addDoctor,
  addDoctorFromExistingUser,
  getDoctorsForDept,
  getDoctorsForHCOrg,
  getDoctorsForOrg,
  getUserByEmail,
  removeDoctorFromDept,
  toggleDoctorHead,
  toggleDoctorPrivileges,
  getOrgDoctors,
} from "./DoctorActions";
import {
  hideLoader,
  showLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";
import { addFullName } from "../../utilities/utilityFunctions";
/**
 * function to add doctor
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const addDoctorRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = "department/caregiver";

    return new HttpRequest(dispatch, url, "post", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Staff created successfully", "success"));

        dispatch(addDoctor(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar(`${error.response.data.error}`, "error"));
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to add doctor form existing user
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const addDoctorFromExistingUserRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = "department/careGiverAlreadyExist";

    return new HttpRequest(dispatch, url, "post", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Staff created successfully", "success"));
        dispatch(addDoctorFromExistingUser(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar(`${error.response.data.error}`, "error"));
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get doctors of a organization
 * @param id: id for api request
 * @param data: data for api request
 * @param isHideLoader: isHideLoader for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getDoctorsForOrgRequest = (id, data, isHideLoader) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = data.searchData ? data.searchData : "";

  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }

    const url = `department/org/${id}/caregiver?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        resData.rows = addFullName(resData.rows);

        dispatch(getDoctorsForOrg(resData));

        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.resolve(resData);
      },
      (error) => {
        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.reject(error);
      }
    );
  };
};

export const getDoctorsRequest = () => {
  return (dispatch) => {
    const url = `department/caregivers`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        resData.rows = addFullName(resData.rows);

        dispatch(getDoctorsForOrg(resData));
        return Promise.resolve(resData);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  };
};

export const getOrgDoctorsRequest = () => {
  return (dispatch) => {
    const url = `department/doctors`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        resData.rows = addFullName(resData.rows);

        dispatch(getOrgDoctors(resData));
        return Promise.resolve(resData);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get doctors of a healthcare organization
 * @param id: id for api request
 * @param data: data for api request
 * @param isHideLoader: isHideLoader for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getDoctorsForHCOrgRequest = (id, data, isHideLoader) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = data.searchData ? data.searchData : "";

  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }

    const url = `healthcareorg/${id}/caregiver?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        resData.rows = addFullName(resData.rows);

        dispatch(getDoctorsForHCOrg(resData));

        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.resolve(resData);
      },
      (error) => {
        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get doctors of a department
 * @param id: id for api request
 * @param data: data for api request
 * @param isHideLoader: isHideLoader for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getDoctorsForDeptRequest = (id, data, isHideLoader) => {
  let offset = data.page * data.rowsPerPage;
  let limit = data.rowsPerPage;
  let searchData = data.searchData ? data.searchData : "";

  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }

    const url = `department/${id}/caregiver?offset=${offset}&limit=${limit}&searchData=${JSON.stringify(
      searchData
    )}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        let resData = res.data.data;
        resData.rows = addFullName(resData.rows);

        dispatch(getDoctorsForDept(resData));

        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.resolve(resData);
      },
      (error) => {
        dispatch(hideLoader());

        if (!isHideLoader) {
          dispatch(hideLoader());
        }

        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to remove doctor from department
 * @param id: id for api request
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const removeDoctorFromDeptRequest = (id, data) => {
  return (dispatch) => {
    dispatch(showLoader());

    const url = `department/removeCaregiverToDept/${id}`;

    return new HttpRequest(dispatch, url, "patch", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Doctor removed successfully", "success"));

        dispatch(removeDoctorFromDept(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Doctor not removed, try again later", "error"));
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to toggle doctor head
 * @param doctorId: doctorId for api request
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const toggleDoctorHeadRequest = (doctorId, data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `teamCaregiver/${doctorId}/enabledOrDisabledHeadDoctor`;

    return new HttpRequest(dispatch, url, "patch", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Successfully changed the status", "success"));
        dispatch(toggleDoctorHead(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to toggle doctor clinical privileges
 * @param doctorId: doctorId for api request
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const toggleDoctorPrivilegesRequest = (doctorId, data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `healthcareOrgCaregiver/${doctorId}/enabledOrDisabledClinicalPrevilige`;

    return new HttpRequest(dispatch, url, "patch", data).send().then(
      (res) => {
        dispatch(hideLoader());
        res.data.data.clinicalPrivileges &&
          dispatch(showSnackbar("Clinical privileges enabled.", "success"));
        !res.data.data.clinicalPrivileges &&
          dispatch(showSnackbar("Clinical privileges disabled.", "success"));

        dispatch(toggleDoctorPrivileges(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Error, try again", "error"));
        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get user by email
 * @param email: email for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getUserByEmailRequest = (email) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `users/${email}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());

        dispatch(getUserByEmail(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());

        return Promise.reject(error);
      }
    );
  };
};

/**
 * function to get signed url
 * @param data: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const getSignedUrlRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `users/profilePic/signedURL`;
    return new HttpRequest(dispatch, url, "post", data)
      .send()
      .then((res) => {
        dispatch(hideLoader());
        return Promise.resolve(res.data.data);
      })
      .catch((error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      });
  };
};

/**
 * function to upload file on signed url
 * @param url: url for api request
 * @param file: data for api request
 * @returns {function(*=): Promise<unknown>}
 */
export const uploadToS3Request = (url, file) => {
  return (dispatch) => {
    dispatch(showLoader());
    return new HttpRequest(dispatch, url, "put", file)
      .s3Upload()
      .then((res) => {
        dispatch(hideLoader());
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      });
  };
};
